import { render, staticRenderFns } from "./QuestionnaireGuide.vue?vue&type=template&id=7046504c&scoped=true"
import script from "./QuestionnaireGuide.vue?vue&type=script&lang=js"
export * from "./QuestionnaireGuide.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireGuide.vue?vue&type=style&index=0&id=7046504c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046504c",
  null
  
)

export default component.exports